module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Corte")]), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n              Creada por:"), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v(_vm._s(_vm.email.user_created.name) + " - " + _vm._s(_vm.email.created_at) + "\n              ")])])]), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6 xxl:col-span-12"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.email.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3 xxl:col-span-12"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Numero de Pieza(s)")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "v-model": _vm.email.number,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('number', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n                  " + _vm._s(num) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3 xxl:col-span-12"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.email.date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('date', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "v-model": _vm.aux_email.project_id,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('project_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.aux_email.campaign_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('campaign_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.email.state_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('state_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                  " + _vm._s(state.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.email.user_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('user_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "my-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.email.path
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('path', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Respuesta")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.email.response
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('response', $event)
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.email.versions.length) ? _c('div', [_vm._m(1), _vm._v(" "), _vm._l((_vm.email.versions), function(version) {
    return _c('div', {
      staticClass: "grid grid-cols-12 items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.created_at) + "\n                ")]), _vm._v(" "), (version.path) ? _c('a', {
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]), _vm._v(" "), (version.response_observations) ? _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.response_observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.updated_at) + "\n                ")]), _vm._v(" "), (version.response_path) ? _c('a', {
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]) : _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_c('form', {
      staticClass: "intro-y gap-3",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_observations),
        expression: "version_current.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "1",
        "required": ""
      },
      domProps: {
        "value": (_vm.version_current.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_path),
        expression: "version_current.response_path"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.version_current.response_path)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_path", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(2, true)])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-5 sm:col-span-5"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.path),
      expression: "version.path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "path", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(3)])])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n                Modificar\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Versiones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "editversion"
    }
  }, [_vm._v("\n                      Responder\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-8 col-span-3 sm:col-span-3"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n                Crear Nueva Version\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f9c2f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/EditEmail.vue
// module id = 446
// module chunks = 1